export const deliveryModal = {
  delivery_time: 'Delivery time',
  select_your_table: 'Select your table',
  currently_closed: 'Currently Closed',
}
